// extracted by mini-css-extract-plugin
module.exports = {"slider-arrow-container":"SliderArrows_slider-arrow-container__2cgDJ","slider-arrow":"SliderArrows_slider-arrow__1uuti"};